module.exports = __webpack_public_path__ + "static/img/aepic-19.833358a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-19.jpg
// module id = 45Jx
// module chunks = 51